import React from 'react';

// Dart themed icons/SVGs
export const dartThemes = {
    'default': (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full text-gray-500 dark:text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
    ),
    'bullseye': (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
        </svg>
    ),
    'dartboard': (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
    ),
    'dart': (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 11H5m14 0a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a2 2 0 012-2m7 0V5a2 2 0 012-2h2a2 2 0 012 2v6M7 11V5a2 2 0 00-2-2H3a2 2 0 00-2 2v6" />
        </svg>
    ),
    'trophy': (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
    ),
    'star': (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.691h4.915c.971 0 1.371 1.24.588 1.81L17.63 13.04a1 1 0 00-.363 1.118l1.519 4.674c.3.921-.755 1.688-1.539 1.118l-4.915-3.57a1 1 0 00-1.118 0l-4.915 3.57c-.784.57-1.838-.197-1.539-1.118l1.519-4.674a1 1 0 00-.363-1.118L2.92 9.092c-.783-.57-.383-1.81.588-1.81h4.915a1 1 0 00.95-.691l1.519-4.674z" />
        </svg>
    ),
    'fire': (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full text-orange-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c-2 3 4 2 4 5V7a4 4 0 01-4-4H5a4 4 0 00-4 4v14a3 3 0 003 3h14a3 3 0 003-3v-5h-3z" />
        </svg>
    ),
    'dart_with_wings': (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full text-purple-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2L10 14m0 0a.5.5 0 100-1 0.5 0.5 0 000 1zM21 12h-7l-3-3m0 0l-3-3m3 3l3-3m-3 3v6l3 3m0 0l-3 3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    'double_dart': (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full text-teal-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 14v6m-3-4h.01M15 10h.01M12 16h.01M16 17h.01M16 10H5m14 0a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a2 2 0 012-2m7 0V5a2 2 0 012-2h2a2 2 0 012 2v6M7 11V5a2 2 0 00-2-2H3a2 2 0 00-2 2v6M17 17l-1 1m-4-4l-1 1M10 10l-1 1M14 14l-1 1" />
        </svg>
    ),
    'target_with_dart': (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-full w-full text-gray-700 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 6l3 1m0 0l-3 9a5 5 0 0010.283 2.236l3-9m-3 9l2-8m-3 6h.01M18 9l3-9m-3 9a2 2 0 100 4m0-4v4m0-4h4l-3 9m-2-2h.01M12 12h.01" />
        </svg>
    )
};